import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgencySelector from '@hooks/useAgencySelector'
import useCampaignQuoteTemplate, { useCampaignQuoteTemplateForm } from '@hooks/useCampaignQuoteTemplate'

import CampaignQuoteTemplateDetails from '../CampaignQuoteTemplateDetails'
import CampaignQuoteTemplateTools from '../../../../components/CampaignQuoteTemplateTools'
import PageLayout from '../../../../components/PageLayout'

interface PageContentProps {
  campaignQuoteTemplateId: number,
}

const PageContent = (props: PageContentProps) => {
  const { campaignQuoteTemplateId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateCampaignQuoteTemplate,
    },
  } = pageContext

  const { selectedAgencyId } = useAgencySelector()

  const campaignQuoteTemplatePayload = useCampaignQuoteTemplate({ id: campaignQuoteTemplateId }, {
    generateUrlsOptions: {
      prefixRoute: `agencies/${selectedAgencyId}/manage`,
    },
  })
  const {
    campaignQuoteTemplate,
    callbacks: {
      updateCampaignQuoteTemplate: updateFn,
    },
    loading,
    updating,
  } = campaignQuoteTemplatePayload

  const campaignQuoteTemplateFormPayload = useCampaignQuoteTemplateForm(campaignQuoteTemplate)
  const { entityState, saveEnabled } = campaignQuoteTemplateFormPayload

  const updateCampaignQuoteTemplatePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Quote Template Updated',
  }

  return (
    <PageLayout activeTabBarItemKey="settings" campaignQuoteTemplatePayload={campaignQuoteTemplatePayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <CampaignQuoteTemplateDetails campaignQuoteTemplateFormPayload={campaignQuoteTemplateFormPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                onClick={() => updateCampaignQuoteTemplate(updateCampaignQuoteTemplatePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <CampaignQuoteTemplateTools campaignQuoteTemplatePayload={campaignQuoteTemplatePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
